function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M421.914,229.422c-20.026,0-39.169-8.932-52.088-24.101c-25.692-3.409-45.188-25.273-45.188-51.708 c0-8.061,1.857-15.928,5.355-23.036c-13.017-7.399-21.544-21.372-21.544-37.086c0-23.516,19.131-42.646,42.646-42.646 c7.806,0,15.281,2.078,21.806,5.974c8.839-8.38,20.619-13.175,33.075-13.175c26.517,0,48.089,21.572,48.089,48.089 c0,2.916-0.258,5.797-0.771,8.625c22.434,11.604,36.958,34.96,36.958,60.726C490.254,198.766,459.597,229.422,421.914,229.422z  M351.097,70.845c-12.487,0-22.646,10.159-22.646,22.646c0,10.973,7.819,20.346,18.593,22.286c3.56,0.642,6.495,3.154,7.678,6.571 c1.183,3.418,0.428,7.208-1.974,9.911c-5.229,5.887-8.108,13.47-8.108,21.354c0,17.287,13.516,31.404,30.77,32.139 c3.019,0.129,5.816,1.615,7.613,4.044c9.228,12.473,23.402,19.626,38.893,19.626c26.654,0,48.34-21.685,48.34-48.339 c0-20.485-12.975-38.816-32.286-45.613c-2.578-0.907-4.673-2.831-5.796-5.322c-1.123-2.492-1.178-5.335-0.151-7.868 c1.357-3.347,2.046-6.896,2.046-10.547c0-15.488-12.601-28.089-28.089-28.089c-9.385,0-18.115,4.663-23.352,12.473 c-1.672,2.493-4.375,4.104-7.363,4.386c-2.98,0.286-5.945-0.791-8.056-2.927C362.918,73.235,357.197,70.845,351.097,70.845z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M421.914,194.567c-5.522,0-10-4.478-10-10s4.478-10,10-10c7.436,0,13.485-6.049,13.485-13.484 c0-5.722-3.618-10.84-9.004-12.735c-5.209-1.833-7.946-7.543-6.112-12.753s7.54-7.948,12.753-6.112 c13.376,4.708,22.363,17.407,22.363,31.601C455.399,179.546,440.378,194.567,421.914,194.567z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M282.956,66.611c-18.365,0-33.306-14.94-33.306-33.306S264.591,0,282.956,0s33.306,14.94,33.306,33.306 S301.321,66.611,282.956,66.611z M282.956,20c-7.337,0-13.306,5.969-13.306,13.306s5.969,13.306,13.306,13.306 s13.306-5.969,13.306-13.306S290.293,20,282.956,20z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M444.752,512c-5.522,0-10-4.478-10-10v-72.164c0-5.522,4.478-10,10-10s10,4.478,10,10V502 C454.752,507.522,450.274,512,444.752,512z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M444.751,405.26c-0.65,0-1.311-0.07-1.95-0.2s-1.27-0.319-1.87-0.569c-0.61-0.25-1.189-0.561-1.729-0.921 c-0.551-0.359-1.061-0.779-1.521-1.239c-1.86-1.86-2.93-4.44-2.93-7.07c0-0.65,0.069-1.31,0.2-1.96c0.13-0.63,0.319-1.26,0.569-1.87 c0.25-0.6,0.561-1.18,0.92-1.72c0.36-0.55,0.78-1.061,1.24-1.521s0.97-0.88,1.521-1.239c0.54-0.37,1.119-0.671,1.729-0.921 c0.601-0.25,1.23-0.449,1.87-0.579c1.29-0.261,2.61-0.261,3.91,0c0.63,0.13,1.26,0.329,1.87,0.579c0.6,0.25,1.18,0.551,1.72,0.921 c0.55,0.359,1.06,0.779,1.52,1.239c0.461,0.46,0.881,0.971,1.24,1.521c0.36,0.54,0.67,1.12,0.92,1.72c0.25,0.61,0.45,1.24,0.57,1.87 c0.13,0.65,0.2,1.31,0.2,1.96c0,2.63-1.07,5.21-2.931,7.07c-0.46,0.46-0.97,0.88-1.52,1.239c-0.54,0.36-1.12,0.671-1.72,0.921 c-0.61,0.25-1.24,0.439-1.87,0.569C446.061,405.189,445.4,405.26,444.751,405.26z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M444.752,294.991h-80.443c-15.871-27.825-40.812-50.224-71.615-62.683v-31.586h12.113c5.522,0,10-4.478,10-10v-45.556 c0-5.522-4.478-10-10-10h-14.608V98.822c0-5.522-4.478-10-10-10h-83.896c-5.522,0-10,4.478-10,10v36.345h-14.607 c-5.522,0-10,4.478-10,10v45.556c0,5.522,4.478,10,10,10h12.112v31.586c-30.804,12.459-55.744,34.857-71.615,62.683H31.748 c-5.522,0-10,4.478-10,10V502c0,5.522,4.478,10,10,10s10-4.478,10-10V314.991h60.972c-6.229,16.25-9.596,33.782-9.596,51.883 c0,21.28,4.604,41.505,12.868,59.731H73.485c-5.522,0-10,4.478-10,10V502c0,5.522,4.478,10,10,10h329.529c5.522,0,10-4.478,10-10 v-65.395c0-5.522-4.478-10-10-10h-32.507c8.264-18.226,12.868-38.451,12.868-59.731c0-18.101-3.367-35.632-9.596-51.883h60.972 v47.888c0,5.522,4.478,10,10,10s10-4.478,10-10v-57.888C454.752,299.469,450.274,294.991,444.752,294.991z M206.302,108.822h63.896 v26.345h-63.896V108.822z M181.694,155.167h113.112v25.556H181.694V155.167z M197.095,248.673c4.019-1.399,6.712-5.188,6.712-9.444 v-38.506h68.887v38.506c0,4.256,2.693,8.045,6.712,9.444c25.362,8.829,46.521,25.311,61.255,46.318H135.84 C150.574,273.984,171.733,257.502,197.095,248.673z M315.243,339.362H161.258c3.155-8.826,7.827-17.073,13.83-24.371h126.324 C307.416,322.29,312.088,330.536,315.243,339.362z M319.986,366.874c0,45.07-36.667,81.737-81.736,81.737 s-81.736-36.667-81.736-81.737c0-2.509,0.114-5.018,0.341-7.512h162.791C319.872,361.855,319.986,364.364,319.986,366.874z  M83.485,492v-45.395h33.554c12.228,18.527,28.586,34.099,47.753,45.395H83.485z M393.015,446.605V492h-81.307 c19.167-11.295,35.525-26.867,47.753-45.395H393.015z M363.376,366.874C363.376,435.869,307.245,492,238.25,492 s-125.126-56.131-125.126-125.126c0-18.299,3.99-35.923,11.269-51.883h26.329c-5.939,10.002-10.134,20.977-12.357,32.474 c-1.229,6.356-1.852,12.887-1.852,19.409c0,56.099,45.639,101.737,101.736,101.737s101.736-45.639,101.736-101.737 c0-6.525-0.623-13.056-1.851-19.409c-2.222-11.496-6.417-22.471-12.356-32.474h26.328 C359.386,330.951,363.376,348.575,363.376,366.874z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

const SvgAlchemy = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    enableBackground: "new 0 0 512 512"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  style: {
    fill: "#A84926"
  },
  points: "120.484,436.606 73.486,436.606 73.486,502 238.25,502  "
}), /*#__PURE__*/React.createElement("polyline", {
  style: {
    fill: "#A84926"
  },
  points: "238.25,502 403.014,502 403.014,436.606 356.016,436.606  "
})), /*#__PURE__*/React.createElement("rect", {
  x: 196.301,
  y: 98.82,
  style: {
    fill: "#FF6243"
  },
  width: 83.9,
  height: 46.34
}), /*#__PURE__*/React.createElement("rect", {
  x: 171.691,
  y: 145.17,
  style: {
    fill: "#81B4A7"
  },
  width: 133.11,
  height: 45.555
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#B0DBD0"
  },
  d: "M282.694,239.228v-48.505h-88.887v48.505c-52.795,18.38-90.682,68.588-90.682,127.646 c0,74.628,60.498,135.126,135.126,135.126s135.126-60.498,135.126-135.126C373.376,307.816,335.488,257.608,282.694,239.228z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#FFC477"
  },
  d: "M305.971,304.991H170.529c-11.17,12.217-19.078,27.467-22.346,44.371h180.134 C325.05,332.458,317.141,317.208,305.971,304.991z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#2C7B7E"
  },
  d: "M148.183,349.363c-1.096,5.669-1.67,11.523-1.67,17.512c0,50.665,41.072,91.737,91.737,91.737 s91.737-41.072,91.737-91.737c0-5.989-0.574-11.843-1.67-17.512H148.183z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#FFC477"
  },
  d: "M480.254,161.083c0-25.428-16.269-47.057-38.965-55.045c1.791-4.417,2.778-9.246,2.778-14.305 c0-21.036-17.053-38.089-38.089-38.089c-13.195,0-24.822,6.71-31.657,16.903c-5.919-5.99-14.137-9.702-23.223-9.702 c-18.03,0-32.647,14.616-32.647,32.647c0,16.041,11.57,29.38,26.82,32.128c-6.614,7.446-10.631,17.25-10.631,27.993 c0,22.678,17.901,41.174,40.344,42.131c10.627,14.365,27.691,23.679,46.931,23.679C454.134,219.422,480.254,193.303,480.254,161.083 z"
}), _ref, _ref2, /*#__PURE__*/React.createElement("circle", {
  style: {
    fill: "#FF9929"
  },
  cx: 282.951,
  cy: 33.31,
  r: 23.305
}), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlchemy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alchemy.10b63630.svg";
export { ForwardRef as ReactComponent };